import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parametrizacoes',
  templateUrl: './parametrizacoes.component.html',
  styleUrls: ['./parametrizacoes.component.sass']
})
export class ParametrizacoesComponent implements OnInit {

  mostrarAlerta: boolean = false;
  showButtons: boolean = true;
  pageNumber: number;
  titulo: string;

  constructor() { }

  ngOnInit(): void {
  }

  mostrarAlertaNoComponente() {
    this.mostrarAlerta = !this.mostrarAlerta
  }

  selectComponent(pageNumber: number) {
    switch (pageNumber){
      case 1:
        this.showButtons = false;
        this.pageNumber = pageNumber;
        this.titulo = "Parametrização Campanha";
        break;

      case 2:
        this.showButtons = false;
        this.pageNumber = pageNumber;
        this.titulo = "Parametrização Exceção";
        break;

      case 3:
        this.showButtons = false;
        this.pageNumber = pageNumber;
        break;

      default:
        this.showButtons = true;
        break;

    }
  }

  voltarParaAbaAnterior(): void {
    this.showButtons = true
    this.pageNumber = null;

  }
}
